/**
 * Rollout constants (frontend phase-14).
 *
 * The flag keys are the backend's, verbatim — `api_v2/feature_flags.py::DEFAULT_FLAGS`. They
 * are listed here rather than typed as `string` so that `useFeatureFlag('v2_chekout')` is a
 * compile error rather than a feature that silently never appears.
 */

export const FLAGS = {
  auth: 'v2_auth',
  landlord: 'v2_landlord',
  affiliate: 'v2_affiliate',
  onboarding: 'v2_onboarding',
  marketplace: 'v2_marketplace',
  checkout: 'v2_checkout',
  commissions: 'v2_commissions',
} as const

export type FlagKey = (typeof FLAGS)[keyof typeof FLAGS]

/** Every flag key, for the debug panel. */
export const ALL_FLAGS: readonly FlagKey[] = Object.values(FLAGS)

/**
 * The build's own version, stamped at build time.
 *
 * `VITE_APP_VERSION` is the API contract version this build was compiled against; it is
 * compared with the API's `X-Api-Version` to detect skew. `VITE_APP_RELEASE` is the commit and
 * is only ever a label — for the error tracker and the "what's new" surface.
 */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || '2.0.0'
export const APP_RELEASE = import.meta.env.VITE_APP_RELEASE || 'dev'

/** Where the classic portal lives. Empty means "no way back is configured", and the link hides. */
export const LEGACY_PORTAL_URL = import.meta.env.VITE_LEGACY_PORTAL_URL || '/portal-v2/'

/** How often the SPA asks the public status endpoint for a banner and the API's version. */
export const STATUS_POLL_MS = 5 * 60 * 1000

export const ROUTES = {
  portalPreference: '/shared/portal-preference/',
  status: '/public/rollout/status/',
  legacyRedirects: '/public/rollout/legacy-redirects/',
} as const

/** `localStorage` keys. Per-viewer conveniences only; nothing here is a decision of record. */
export const STORAGE = {
  dismissedBanner: 'apmp.banner.dismissed',
  seenRelease: 'apmp.release.seen',
  skewDismissed: 'apmp.skew.dismissed',
} as const
